// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../node_modules/@ant-design/icons-react-native/fonts/antoutline.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../node_modules/@ant-design/icons-react-native/fonts/antfill.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Web-only @font-face registrations for icon fonts used by
   @ant-design/icons-react-native. On native these fonts are linked by the
   bundler; on web react-native-web renders icons as <Text> with these exact
   font-family names, so without these rules the glyphs show as tofu boxes. */
@font-face {
  font-family: 'antoutline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'antfill';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./web/fonts.css"],"names":[],"mappings":"AAAA;;;6EAG6E;AAC7E;EACE,yBAAyB;EACzB,+DAAkG;EAClG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA+F;EAC/F,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Web-only @font-face registrations for icon fonts used by\n   @ant-design/icons-react-native. On native these fonts are linked by the\n   bundler; on web react-native-web renders icons as <Text> with these exact\n   font-family names, so without these rules the glyphs show as tofu boxes. */\n@font-face {\n  font-family: 'antoutline';\n  src: url('../node_modules/@ant-design/icons-react-native/fonts/antoutline.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'antfill';\n  src: url('../node_modules/@ant-design/icons-react-native/fonts/antfill.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
